import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DriverLicenceRestriction } from '../../../model/licence.model';

@Component({
  selector: 'vrm-licence-restrictions-table',
  templateUrl: './licence-restrictions-table.component.html',
  styleUrls: ['./licence-restrictions-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicenceRestrictionsTableComponent {
  @Input() public dataSource: DriverLicenceRestriction[] = [];
  protected columns = ['code', 'description'];
}
